import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import PurchasingReportActions from '../../../../reducers/modules/report/purchasing-report/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/purchasing-report'

export default class PurchasingReportMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(PurchasingReportActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      PurchasingReportMiddleware.showOne(dispatch, params);
      dispatch(PurchasingReportActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(PurchasingReportActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(PurchasingReportActions.process());
          PurchasingReportMiddleware.showlist(dispatch, params);
        };
  }

  static listSupplier(params){
    return (dispatch) => {
        dispatch(PurchasingReportActions.process());
        PurchasingReportMiddleware.showlistSupplier(dispatch, params);
      };
}

static listSupplierDetail(params){
  return (dispatch) => {
      dispatch(PurchasingReportActions.process());
      PurchasingReportMiddleware.showlistSupplierDetail(dispatch, params);
    };
}

static listInvoiceDetail(params){
  return (dispatch) => {
      dispatch(PurchasingReportActions.process());
      PurchasingReportMiddleware.showlistInvoiceDetail(dispatch, params);
    };
}

static listItem(params){
  return (dispatch) => {
      dispatch(PurchasingReportActions.process());
      PurchasingReportMiddleware.showlistDataItem(dispatch, params);
    };
}

static listDataPO(params){
  return (dispatch) => {
      dispatch(PurchasingReportActions.process());
      PurchasingReportMiddleware.showlistDataPO(dispatch, params);
    };
}

static listDataReceiving(params){
  return (dispatch) => {
      dispatch(PurchasingReportActions.process());
      PurchasingReportMiddleware.showlistDataReceiving(dispatch, params);
    };
}

  static showExcel(params){
    return (dispatch) => {
        dispatch(PurchasingReportActions.process());
        PurchasingReportMiddleware.beforeShowExcel(dispatch, params);
      };
}

  static listing(params){
    return (dispatch) => {
        dispatch(PurchasingReportActions.process());
        PurchasingReportMiddleware.showlisting(dispatch, params);
      };
}
  static reset(){
    return (dispatch) => {
        dispatch(PurchasingReportActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(PurchasingReportActions.view());
        PurchasingReportMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(PurchasingReportActions.submit());
        PurchasingReportMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(PurchasingReportActions.submit());
        PurchasingReportMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(PurchasingReportActions.delete());
        PurchasingReportMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      PurchasingReportMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-purchasing-report' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(PurchasingReportActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(PurchasingReportActions.list(response.data.result));
          }
        })
        .catch((error) => {
          PurchasingReportMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlistSupplier(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url:process.env.REST_URL +'report/purchasing-report-supplier',
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(PurchasingReportActions.listSupplier(response.data.result));
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error)
      });
}

static showlistSupplierDetail(dispatch, params){
  axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
      },
      url:process.env.REST_URL +'report/purchasing-report-supplier-detail',
      responseType: 'json',
      params:params
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        dispatch(PurchasingReportActions.listSupplierDetail(response.data.result));
      }
    })
    .catch((error) => {
      PurchasingReportMiddleware.alertHendler(dispatch,error)
    });
}

static showlistInvoiceDetail(dispatch, params){
  axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
      },
      url:process.env.REST_URL +'report/purchasing-report-invoice-detail',
      responseType: 'json',
      params:params
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        dispatch(PurchasingReportActions.listInvoiceDetail(response.data.result));
      }
    })
    .catch((error) => {
      PurchasingReportMiddleware.alertHendler(dispatch,error)
    });
}

static showlistDataItem(dispatch, params){
  axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
      },
      url:process.env.REST_URL +'report/purchasing-report-item',
      responseType: 'json',
      params:params
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        dispatch(PurchasingReportActions.listDataItem(response.data.result));
      }
    })
    .catch((error) => {
      PurchasingReportMiddleware.alertHendler(dispatch,error)
    });
}

static showlistDataPO(dispatch, params){
  axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
      },
      url:process.env.REST_URL +'report/purchasing-report-po',
      responseType: 'json',
      params:params
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        dispatch(PurchasingReportActions.listPO(response.data.result));
      }
    })
    .catch((error) => {
      PurchasingReportMiddleware.alertHendler(dispatch,error)
    });
}

static showlistDataReceiving(dispatch, params){
  axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
      },
      url:process.env.REST_URL +'report/purchasing-report-receiving',
      responseType: 'json',
      params:params
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        dispatch(PurchasingReportActions.listReceiving(response.data.result));
      }
    })
    .catch((error) => {
      PurchasingReportMiddleware.alertHendler(dispatch,error)
    });
}

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(PurchasingReportActions.list(response.data.result));
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchasingReportActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(PurchasingReportActions.process(),PurchasingReportMiddleware.showlist(dispatch, params));
          PurchasingReportMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchasingReportActions.process(),PurchasingReportMiddleware.showlist(dispatch,search));
          dispatch(PurchasingReportActions.success());
          PurchasingReportMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${PurchasingReportMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(PurchasingReportActions.process(),PurchasingReportActions.showlist(dispatch,search));
          // dispatch(PurchasingReportActions.success());
          // PurchasingReportMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        PurchasingReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(PurchasingReportActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(PurchasingReportActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
